import "../styles/skills.css"
import "../styles/art/nightsky.css"

import { SkillItem } from "../components/SkillItem"
import { MountainPlanetIII } from "../components/art/MountainPlanetIII"
import { useEffect } from "react"
import { skillData } from "../const/skillData"
import { NightSky } from "../components/art/NightSky"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import applyLandscapeAnimation from "../helper/landscapeAnimationHelper"


function PageSkills() {

    useEffect(() => {
        window.scrollTo(0,0)

        let t1 = gsap.timeline({onStart: setScrollTriggers})
        t1.set(".history-timeline__timeline-item", {x: "200vw",}, 0)
        t1.set(".main-skills__section", {y: "-50vh",}, 0)
        t1.fromTo(".background-skills", {backgroundImage: `linear-gradient(to bottom, black 0%, black 80%, black 100%)`,},
        {
            backgroundImage: `linear-gradient(to bottom, rgba(17, 5, 29) 20%, rgba(116, 46, 173, 1) 92%, rgba(220, 36, 226, 1) 100%)`,
            duration: 1,
            ease: "power3.in",
        }, 0)
        t1.fromTo(".main-skills__section", {
            y: "-50vh",
            opacity: 0
        },
        {
            y: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.25
        }, 0.25)
    }, [])

    function setScrollTriggers() {
        gsap.registerPlugin(ScrollTrigger)
        let tScrollBackground = gsap.timeline()
        let skyAnimTrigger = ScrollTrigger.create({
            trigger: ".main-skills",
            start: "top top",
            end: "center top",
            scrub: true,
            animation: gsap.fromTo(".sky-background", {
                backgroundImage: `linear-gradient(to bottom, rgba(17, 5, 29) 20%, rgba(116, 46, 173, 1) 92%, rgba(220, 36, 226, 1) 100%)`,
            },
            {
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,1) 20%, rgba(27,7,54,1) 92%, rgba(44,1,47,1) 100%)`,
                ease: "power2.in",
                duration: 1
            })
        })

        let mountainTrigger = applyLandscapeAnimation({
            trigger: ".main-skills",
            endTrigger: ".main-skills",
            start: "top top",
            end: "center top",
            y: "80vh"
        })
        tScrollBackground.add(skyAnimTrigger.animation, 0)
        tScrollBackground.add(mountainTrigger.animation, 0)


    }


    const skillCategories = Object.keys(skillData)
    const skillDataItems = Object.values(skillData)

    return (
        <>
            <div className="sky-background background-skills"></div>
            <main className="main-skills">
                <NightSky></NightSky>
                <h1>My skills</h1>
                {skillDataItems.map((category, i) => {
                    return (
                        <section className="main-skills__section" key={i}>
                            <h2>{skillCategories[i]}</h2>
                                <div className="skills-list">
                                    {category.map((skill, i) => <SkillItem info={skill} key={i}></SkillItem>)}
                                </div>
                        </section>
                    )
                })}
                <div className="planet-landscape-container">
                    <MountainPlanetIII></MountainPlanetIII>
                    <MountainPlanetIII></MountainPlanetIII>
                    <MountainPlanetIII></MountainPlanetIII>
                    <div className="planet-ii-surface"></div>
                </div>
                
            </main>
        </>
        
    )
}

export default PageSkills